import liff from '@line/liff'

let authorization = null

export default {
    async getLineIdForLiff (liffId) {
        await liff.init({ liffId }).catch(err => { throw err })
        const profile = await liff.getProfile()
        return profile.userId
    },

    async openWindow (liffId, url) {
        await liff.init({ liffId }).catch(err => { throw err })
        await liff.openWindow({ url })
    },

    async closeWindow (liffId) {
        await liff.init({ liffId }).catch(err => { throw err })
        await liff.closeWindow()
    },

    setAuthorization (auth) {
        authorization = auth
    },

    getAuthorization () {
        return authorization
    },

    isInLineBrowser () {
        const { userAgent } = navigator
        // web open in LINE App Liff or LINE in app browser (desktop)
        return liff.isInClient() || (!liff.isInClient() && userAgent.includes('Line'))
    }
}
